export enum ParcelTypeEnum {
  MONTHLY_FEE = 'MENSALIDADE',
  QUARTERLY = 'TRIMESTRAL',
  SEMIANNUAL = 'SEMESTRAL',
  ANNUAL = 'ANUAL',
  DEPLOYMENT = 'IMPLANTAÇÃO',
  ADHESION = 'ADESÃO',
  DAYS_COUNT = 'DIAS CORRIDOS',
  MANUAL = 'MANUAL',
  OS = 'OS'
}

export enum ParcelTypeIdEnum {
  'MENSALIDADE' = 1,
  'TRIMESTRAL' = 2,
  'SEMESTRAL' = 3,
  'ANUAL' = 4,
  'IMPLANTAÇÃO' = 5,
  'ADESÃO' = 6,
  'DIAS CORRIDOS' = 7,
  'MANUAL' = 8,
  'OS' = 9
}

export function getParcelTypeDescriptionByValue(value: string) {
  const indexOfS = Object.values(ParcelTypeIdEnum).indexOf(
    value as unknown as ParcelTypeIdEnum
  );

  const key = Object.keys(ParcelTypeIdEnum)[indexOfS];

  return key;
}

export function getParcelTypeDescriptionById(id: number): ParcelTypeEnum | null {
  switch (id) {
    case 1: return ParcelTypeEnum.MONTHLY_FEE;
    case 2: return ParcelTypeEnum.QUARTERLY;
    case 3: return ParcelTypeEnum.SEMIANNUAL;
    case 4: return ParcelTypeEnum.ANNUAL;
    case 5: return ParcelTypeEnum.DEPLOYMENT;
    case 6: return ParcelTypeEnum.ADHESION;
    case 7: return ParcelTypeEnum.DAYS_COUNT;
    case 8: return ParcelTypeEnum.MANUAL;
    case 9: return ParcelTypeEnum.OS;
    default: return null;
  }
}

